module.exports = __webpack_public_path__ + "cb00f8c86b932e17cf0ff715cd641769.pdf";